import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

/**
 * Объяснение истёкшей сессии (401) вместо молчаливого `location.replace('/login')`.
 *
 * Раньше при 401 приложение мгновенно уходило на /login без единого слова —
 * оператор видел форму входа и не понимал, почему его выбросило и куда делись
 * данные. Модалка называет причину и показывает адрес, на который пользователь
 * вернётся после повторного входа (`returnUrl`, см. api/client.js).
 *
 * @param {boolean}  isOpen    показывать ли модалку
 * @param {string}   returnUrl относительный путь, куда вернёт после входа
 * @param {Function} onRelogin переход на страницу входа
 */
const SessionExpiredModal = ({ isOpen = false, returnUrl = "", onRelogin }) => {
  const { t } = useTranslation("errors");

  return (
    <Modal isOpen={isOpen} centered backdrop="static" keyboard={false}>
      <ModalHeader>
        <span className="d-flex align-items-center">
          <i className="mdi mdi-account-clock-outline text-warning me-2" aria-hidden="true" />
          {t("session.expiredTitle")}
        </span>
      </ModalHeader>
      <ModalBody>
        <p className="mb-2">{t("session.expiredBody")}</p>
        {returnUrl ? (
          <p className="text-muted mb-0 small">{t("session.returnHint", { path: returnUrl })}</p>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onRelogin} className="waves-effect waves-light">
          <i className="mdi mdi-login-variant me-1" aria-hidden="true" />
          {t("session.relogin")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SessionExpiredModal.propTypes = {
  isOpen: PropTypes.bool,
  returnUrl: PropTypes.string,
  onRelogin: PropTypes.func.isRequired,
};

export default SessionExpiredModal;
